import { API_URLS } from "constants/apiConstants";
import {
	emptyPayment,
	PaymentPreferences,
	PaymentResponse,
	Reservation,
} from "../types/entities";
import { ApiClient, ApiResponse } from "./requestExecutor";

const apiUrl = process.env.REACT_APP_API_URL;

export class PaymentApi extends ApiClient {
	public fetchPaymentPreferences = async (
		payment: PaymentPreferences
	): Promise<ApiResponse<PaymentResponse>> => {
		try {
			return this.post<PaymentResponse>(
				API_URLS.payment.getPreferencesUrl,
				JSON.stringify(payment)
			);
		} catch (error) {
			console.error("Error al obtener las preferencias del pago:", error);
			throw error;
		}
	};

	public processPayment = async (payment: any): Promise<ApiResponse<any>> => {
		try {
			const formData = JSON.stringify({
				...payment,
				transactionAmount: payment.transaction_amount,
				paymentMethodId: payment.payment_method_id,
				issuerId: payment.issuer_id,
				transaction_amount: undefined,
				payment_method_id: undefined,
				issuer_id: undefined,
			});
			const options = { contentType: "application/json" as const };
			return this.post<any>(
				API_URLS.payment.processPaymentUrl,
				formData,
				options
			);
		} catch (error) {
			console.error("Error al procesar el pago:", error);
			throw error;
		}
	};

	public getPaymentStatus = async (
		paymentId: string
	): Promise<ApiResponse<string>> => {
		try {
			return await this.get<string>(
				API_URLS.payment.getPaymentStatusUrl.replace("{externalReference}", paymentId)
			);
		} catch (error) {
			console.error("Error al obtener el estado del pago:", error);
			throw error;
		}
	};
}
